import 'angucomplete-alt';
import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-chart.js';
import 'angular-clipboard';
import 'angular-cookies';
import 'angular-file-saver';
import 'angular-i18n/angular-locale_pl-pl';
import 'angular-jquery-timepicker';
import 'angular-loading-bar';
import 'angular-messages';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-time-picker';
import 'angular-toastr';
import 'angular-touch';
import 'angular-translate';
import 'angular-ui-router';
import 'angular-ui-switch';
import 'angularjs-datepicker';
import 'chart.js';
import 'file-saver';
import 'firebase/app';
import 'firebase/messaging';
import 'jquery';
import 'malarkey';
import 'moment';
import 'ng-dialog';
import 'ng-file-upload';

import './app/index.module';
import './app/components/_admin/_admin.controller';
import './app/components/_admin/_admin.route';
import './app/components/_company_employee/_company_employee.controller';
import './app/components/_company_employee/_company_employee.route';
import './app/components/_housing_association/housing_association.controller';
import './app/components/_housing_association/housing_association.route';
import './app/components/auth/agreements_dialogs/agreements_dialog.service';
import './app/components/auth/agreements_dialogs/data_processing_dialog/data_processing_dialog.controller';
import './app/components/auth/agreements_dialogs/terms_dialog/terms_dialog.controller';
import './app/components/auth/login/login.component';
import './app/components/auth/login/login.controller';
import './app/components/auth/logo/logo.component';
import './app/components/auth/logo/logo.controller';
import './app/components/auth/notlogged_menu/notlogged_menu.component';
import './app/components/auth/password_reminder/password_remidner.component';
import './app/components/auth/password_reminder/password_reminder.controller';
import './app/components/auth/registration/verify_email/verify_email.controller';
import './app/components/auth/registration/verify_email/verify_email.route';
import './app/components/auth/registration/verify_email_with_password/verify_email_with_password.controller';
import './app/components/auth/registration/verify_email_with_password/verify_email_with_password.route';
import './app/components/auth/set_email/set_email.component';
import './app/components/auth/set_email/set_email.controller';
import './app/components/auth/set_email/set_email.route';
import './app/components/company_configuration/categories/categories.controller';
import './app/components/company_configuration/company-configuration.controller';
import './app/components/company_configuration/company-configuration.route';
import './app/components/company_configuration/exporter/exporter.controller';
import './app/components/company_configuration/exporter/exporter.route';
import './app/components/data-presentation/term-display/term-display.component';
import './app/components/data-presentation/term-display/term-display.controller';
import './app/components/data-presentation/no-results/no-results.component';
import './app/components/delete_dialog/delete.controller';
import './app/components/filters/custom-fields-filters/checkbox/checkbox.component';
import './app/components/filters/custom-fields-filters/checkbox/checkbox.controller';
import './app/components/filters/custom-fields-filters/custom-fields-filters.component';
import './app/components/filters/custom-fields-filters/custom-fields-filters.controller';
import './app/components/filters/pagination/pagination.component';
import './app/components/filters/pagination/pagination.controller';
import './app/components/filters/report-type/report-type-filter.component';
import './app/components/filters/report-type/report-type-filter.controller';
import './app/components/filters/searchable-select/searchable-select.component';
import './app/components/filters/searchable-select/searchable-select.controller';
import './app/components/filters/vat-filter/vat-filter.component';
import './app/components/filters/vat-filter/vat-filter.controller';
import './app/components/flex-ui/exit/flex-ui-exit.component';
import './app/components/flex-ui/menu/flex-ui-menu.component';
import './app/components/flex-ui/menu/flex-ui-menu.controller';
import './app/components/footer/footer.component';
import './app/components/footer/footer.controller';
import './app/components/forms/double-select/double-select.component';
import './app/components/forms/double-select/double-select.controller';
import './app/components/header/upper_header.component';
import './app/components/header/upper_header.controller';

/**
 * Analytics
 */
import './app/components/analytics/analytics-submenu/analytics-submenu.component';
import './app/components/analytics/issues-analytics/issues-analytics-container.controller';
import './app/components/analytics/issues-analytics/issues-analytics.component';
import './app/components/analytics/issues-analytics/issues-analytics.controller';
import './app/components/analytics/group-analytics/group-analytics-container.controller';
import './app/components/analytics/group-analytics/group-analytics.component';
import './app/components/analytics/group-analytics/group-analytics.controller';
import './app/components/analytics/clients-report/clients-report.controller';
import './app/components/analytics/employees-report/employees-report.controller';
import './app/components/analytics/analytics.route';

import './app/components/issues/company_issue_list/bulk_actions/change-status/change-status.controller';
import './app/components/issues/company_issue_list/company_issue_list.controller';
import './app/components/issues/company_issue_list/company_issue_list.route';
import './app/components/issues/company_issue_list/details/add_files_dialog/add_files.controller';
import './app/components/issues/company_issue_list/details/change-additional-personal-data/change-additional-personal-data.controller';
import './app/components/issues/company_issue_list/details/change-category/change-category.controller';
import './app/components/issues/company_issue_list/details/change-client-dialog/change-client.controller';
import './app/components/issues/company_issue_list/details/change-contractor-dialog/change-contractor.controller';
import './app/components/issues/company_issue_list/details/change-costs/change-costs.controller';
import './app/components/issues/company_issue_list/details/change-costs/issue-labour-cost/issue-labour-cost.component';
import './app/components/issues/company_issue_list/details/change-costs/issue-labour-cost/issue-labour-cost.controller';
import './app/components/issues/company_issue_list/details/change-costs/issue-material-cost/issue-material-cost.component';
import './app/components/issues/company_issue_list/details/change-costs/issue-material-cost/issue-material-cost.controller';
import './app/components/issues/company_issue_list/details/change-id/change-id.controller';
import './app/components/issues/company_issue_list/details/change_status_dialog/change_status.controller';
import './app/components/issues/company_issue_list/details/custom-fields/custom-fields.controller';
import './app/components/issues/company_issue_list/details/edit-description/edit-description.controller';
import './app/components/issues/company_issue_list/details/generate-journal/generate-journal.component';
import './app/components/issues/company_issue_list/details/generate-journal/generate-journal.controller';
import './app/components/issues/company_issue_list/details/issue_details.controller';
import './app/components/issues/company_issue_list/details/issue_details.route';
import './app/components/issues/company_issue_list/details/revenue/revenue.controller';
import './app/components/issues/company_issue_list/details/term_dialog/term.controller';
import './app/components/issues/company_issue_list/details/issue-locations-dialog/issue-locations.controller';
import './app/components/issues/company_issue_list/history/history.controller';
import './app/components/issues/company_issue_list/history/history.route';
import './app/components/issues/filters/assigned-to-filter/assigned-to-filter.component';
import './app/components/issues/filters/assigned-to-filter/assigned-to-filter.controller';
import './app/components/issues/filters/category-filter/category-filter.component';
import './app/components/issues/filters/clients-filter/clients-filter.component';
import './app/components/issues/filters/clients-filter/clients-filter.controller';
import './app/components/issues/filters/settlement-filter/settlement-filter.component';
import './app/components/issues/filters/settlement-filter/settlement-filter.controller';
import './app/components/issues/housing_association_issue_list/history/history.controller';
import './app/components/issues/housing_association_issue_list/history/history.route';
import './app/components/issues/housing_association_issue_list/housing_association_issue_list.controller';
import './app/components/issues/housing_association_issue_list/housing_association_issue_list.route';
import './app/components/issues/housing_association_issue_list/journal/journal.component';
import './app/components/issues/housing_association_issue_list/journal/journal.controller';
import './app/components/issues/issue_forms/fragments/additional_personal_data/issue_form_description.component';
import './app/components/issues/issue_forms/fragments/additional_personal_data/issue_form_description.controller';
import './app/components/issues/issue_forms/fragments/assets/assets.component';
import './app/components/issues/issue_forms/fragments/assets/assets.controller';
import './app/components/issues/issue_forms/fragments/category/issue_form_category.component';
import './app/components/issues/issue_forms/fragments/category/issue_form_category.controller';
import './app/components/issues/issue_forms/fragments/category_string/issue_form_category.component';
import './app/components/issues/issue_forms/fragments/category_string/issue_form_category.controller';
import './app/components/issues/issue_forms/fragments/clients/issue_form_clients.component';
import './app/components/issues/issue_forms/fragments/clients/issue_form_clients.controller';
import './app/components/issues/issue_forms/fragments/companies/issue_form_companies.component';
import './app/components/issues/issue_forms/fragments/companies/issue_form_companies.controller';
import './app/components/issues/issue_forms/fragments/company-categories/issue_form_category.component';
import './app/components/issues/issue_forms/fragments/company-categories/issue_form_category.controller';
import './app/components/issues/issue_forms/fragments/custom_fields/issue-form-custom-field-checkbox.component';
import './app/components/issues/issue_forms/fragments/custom_fields/custom_fields.component';
import './app/components/issues/issue_forms/fragments/custom_fields/custom_fields.controller';
import './app/components/issues/issue_forms/fragments/custom_fields/input/input.component';
import './app/components/issues/issue_forms/fragments/custom_fields/input/input.controller';
import './app/components/issues/issue_forms/fragments/custom_fields/radio/radio.component';
import './app/components/issues/issue_forms/fragments/custom_fields/radio/radio.controller';
import './app/components/issues/issue_forms/fragments/custom_fields/select/select.component';
import './app/components/issues/issue_forms/fragments/custom_fields/select/select.controller';
import './app/components/issues/issue_forms/fragments/description/issue_form_description.component';
import './app/components/issues/issue_forms/fragments/description/issue_form_description.controller';
import './app/components/issues/issue_forms/fragments/issue-category/issue-category.component';
import './app/components/issues/issue_forms/fragments/locations/issue_form_locations.component';
import './app/components/issues/issue_forms/fragments/locations/issue_form_locations.controller';
import './app/components/issues/issue_forms/ha_form/ha_issue_form.controller';
import './app/components/issues/issue_view/journal/journal.component';
import './app/components/issues/issue_view/journal/journal.controller';
import './app/components/issues/parts/issue-status/issue-status.component';
import './app/components/issues/parts/issue-status/issue-status.controller';
import './app/components/landing_page/landing_page.controller';
import './app/components/landing_page/landing_page.route';
import './app/components/privacy-policy/privacy-policy.controller';
import './app/components/privacy-policy/privacy-policy.route';
import './app/components/notifications/bell/notifications-bell.component';
import './app/components/notifications/bell/notifications-bell.controller';
import './app/components/periodic_tasks/repeater_configurator/repeater_configurator.component';
import './app/components/periodic_tasks/repeater_configurator/repeater_configurator.controller';
import './app/components/periodic_tasks/task_details/task_details.controller';
import './app/components/periodic_tasks/task_form/task_form.component';
import './app/components/periodic_tasks/task_form/task_form.controller';
import './app/components/periodic_tasks/task_list/task_list.controller';
import './app/components/periodic_tasks/periodic_tasks.route';
import './app/components/server-message/server-message.component';
import './app/components/server-message/server-message.controller';
import './app/components/server-message/server-message.service';
import './app/components/uploader/uploader.component';
import './app/components/uploader/uploader.controller';
import './app/directives/jwTooltip/jwTooltip.directive';
import './app/directives/ngEnter.directive';
import './app/filters/time.filter';
import './app/filters/trusted_html.filter';
import './app/index.config';
import './app/index.constants';
import './app/index.route';
import './app/index.run';
import './app/languages/de';
import './app/languages/en';
import './app/languages/fr';
import './app/languages/pl';
import './app/partials/login/controllers/setNewPassword.controller';
import './app/partials/login/controllers/logout.controller';
import './app/partials/login/routes/login.route';
import './app/partials/universal_scripts/partials/pagination/scripts/controllers/pagination.controller';
import './app/partials/universal_scripts/partials/pagination/scripts/services/pagination.service';

import './app/services/active-state.service';
import './app/services/auth.factory';
import './app/services/bulk-mode.service';
import './app/services/business-relationships.factory';
import './app/services/categories.factory';
import './app/services/companies.factory';
import './app/services/company.factory';
import './app/services/costs.service';
import './app/services/custom-fields.service';
import './app/services/date.service';
import './app/services/documents.factory';
import './app/services/download-file.service';
import './app/services/form_verification.service';
import './app/services/gcm.factory';
import './app/services/gdpr.factory';
import './app/services/ha_employee.factory';
import './app/services/housing_association.factory';
import './app/services/imieszkaniec.factory';
import './app/services/issue-exporter.factory';
import './app/services/issue-materials.factory';
import './app/services/labour-costs.factory';
import './app/services/local_storage.service';
import './app/services/material-costs.factory';
import './app/services/materials.factory';
import './app/services/next.factory';
import './app/services/notifications.factory';
import './app/services/periodic_tasks.factory';
import './app/services/periodic_tasks.service';
import './app/services/reports.factory';
import './app/services/session.factory';
import './app/services/users.factory';
import './app/services/version.factory';
import './app/services/web_push.service';
import './app/translations/_translation.config';
import './app/translations/translation_en';
import './app/translations/translation_pl';

import './polyfills.ts';
import './sentry.ts';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { HttpClientModule } from '@angular/common/http';

import { AuthInterceptorModule } from './app/services/auth-interceptor.service';
import { LocalStorageService } from './app/services/local_storage.service';

@NgModule({
    imports: [
        BrowserModule,
        UpgradeModule,
        HttpClientModule,
        AuthInterceptorModule,
    ],
    providers: [LocalStorageService],
})
export class AppModule {
    // Override Angular bootstrap so it doesn't do anything
    ngDoBootstrap() {}
}

// Bootstrap using the UpgradeModule
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((platformRef) => {
        console.log('Bootstrapping in Hybrid mode with Angular & AngularJS');
        const upgrade = platformRef.injector.get(
            UpgradeModule
        ) as UpgradeModule;
        upgrade.bootstrap(document.body, ['app']);
    });



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/main.ts